import React from 'react';
import * as cls from './trusted-by.module.css';

import { Section } from '../../../ui/components/section';
import { Typography } from '../../../ui/components/typography';
import { UtilitiesLayout } from '../../../ui/layouts/utilities-layout/utilities-layout';

export const TrustedBy = () => {
  return (
    <Section classNameRoot={cls['section-wrapper']}>
      <Typography tag="h2">Trusted by Leading Energy Innovators</Typography>
      <Typography className={cls.description}>
        Founded in the UK and trusted by partners like Octopus Energy, Utilita,
        and SAP, Voltaware now provides AI-powered home energy insights to
        households around the world.
      </Typography>

      <UtilitiesLayout />
    </Section>
  );
};
